import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';

// Match common.timeutils.CLAIM_STALE_SECONDS. A crashed worker never writes a
// failure, so the notice must become retryable even without another snapshot.
const ATTEMPT_LIFETIME_MS = 10 * 60 * 1000;

export default function ResourceDeletionNotice({ resource, onRetry }) {
  const [now, setNow] = useState(Date.now);
  const timestamp = resource.deleting_claimed_at;
  const claimedAt = timestamp?.toMillis ? timestamp.toMillis() : new Date(timestamp || 0).getTime();
  const expiresAt = claimedAt + ATTEMPT_LIFETIME_MS;
  const running = Boolean(timestamp && expiresAt > now);
  useEffect(() => {
    if (!running) return undefined;
    const timer = setTimeout(() => setNow(Date.now()), Math.max(0, expiresAt - Date.now()) + 10);
    return () => clearTimeout(timer);
  }, [running, expiresAt]);

  return (
    <Alert severity={running ? 'info' : 'warning'} sx={{ m: 1 }}>
      <Typography variant="body2">{resource.name || resource.id}: {running ? 'Deleting…' : 'Deletion failed'}</Typography>
      {!running && (
        <Box>
          <Typography variant="caption">Some associated items may already have been removed. Retry deletion to finish cleanup.</Typography>
          <Button size="small" onClick={onRetry}>Retry deletion</Button>
        </Box>
      )}
    </Alert>
  );
}
